import type { Pagination, ProductType } from '@barboxx/models/types';

import { api } from '../../api';

const rootPath = 'products/types';

export function getProductTypes(query?: ProductType.SearchQuery) {
    return api.get<Pagination<ProductType>>(rootPath, query);
}

export function getProductType(id: number) {
    return api.get<ProductType.DetailsResponse>(`${rootPath}/${id}`, undefined);
}

export function postProductType(data: ProductType.CreateRequest) {
    return api.post<ProductType>(rootPath, data);
}

export function putProductType(data: ProductType.UpdateRequest) {
    return api.put<ProductType>(`${rootPath}/${data.id}`, data);
}

export function deleteProductType({ id }: ProductType.DeleteRequest) {
    return api.delete(`${rootPath}/${id}`, undefined);
}
